import { render, staticRenderFns } from "./NotaPreOperatoria.vue?vue&type=template&id=1b31b3c8&scoped=true&"
import script from "./NotaPreOperatoria.vue?vue&type=script&lang=js&"
export * from "./NotaPreOperatoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b31b3c8",
  null
  
)

export default component.exports